/**
 * The product name, as shown to a user.
 *
 * ┌─ ⛔ ONE HOME, BECAUSE IT WAS EIGHT AND THEN IT CHANGED ────────────────────┐
 * │ Renamed from "GoDiving CRM" to "GoChat" on 2026-07-30. It was a literal in  │
 * │ eight components plus index.html plus the TOTP issuer, which is ten places  │
 * │ to find and one to miss.                                                   │
 * │                                                                            │
 * │ Same reasoning as `STATUS_RANK`, `messagingWindow` and `resolveReactions`:  │
 * │ a value with several representations is not a value, it is a coincidence    │
 * │ that holds until one copy is edited. This one had no correctness            │
 * │ consequence, which is exactly why it would have been the one left behind.   │
 * └────────────────────────────────────────────────────────────────────────────┘
 *
 * ⚠️ TWO PLACES CANNOT IMPORT THIS AND ARE LISTED SO THEY ARE FOUND ON THE NEXT
 * RENAME RATHER THAN DISCOVERED:
 *
 *   web/index.html      static HTML, parsed before any module runs. The <title>
 *                       is a literal there.
 *   src/auth/totp.ts    the TOTP issuer, shown in the authenticator app. It is
 *                       BACKEND code, so it cannot import from web/, and it is
 *                       the one instance a rename must not casually change:
 *                       altering the issuer invalidates the label on every
 *                       already-enrolled authenticator entry. See the note there.
 *
 * `ops/check-brand-name.sh` asserts all three agree, so the split cannot drift
 * silently.
 */
export const PRODUCT_NAME = 'GoChat'
